import React from "react";
import { ContactHead } from "../../components/user-components/Header/ContactHead";
import { Contactme } from "../../components/user-components/Contactme/Contactme";
import { Navbar } from "../../components/user-components/NavigationBar/Navbar";

export const Contact = () => {
  return (
    <>
      <Navbar />
      <ContactHead />
      <Contactme />
    </>
  );
};
